import { Injectable }                      from '@angular/core';
import { ModalDismissReasons, NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { VehicleVisualsPlayerComponent } from './vehicle-visuals.player.component';

@Injectable({
  providedIn: 'root'
})
export class VehicleVisualsService {
  constructor (
    private modalService: NgbModal
  ) {}

  play ( url : string, title? : string ) : Promise<any> {
    const playUrl  = this.withAutoPlay(url);
    const modalRef = this.modalService.open(VehicleVisualsPlayerComponent, {
      windowClass: 'vehicle-visuals-player-modal'
    });

    modalRef.componentInstance.title = title;
    modalRef.componentInstance.url   = playUrl;

    return modalRef.result.catch(( reason : any ) => {
      if (this.isDismiss(reason)) {
        return null;
      }

      return Promise.reject(reason);
    });
  }

  private withAutoPlay ( url : string ) : string {
    return url.includes('auto_play=')
      ? url.replace(/auto_play=\d+/, 'auto_play=1')
      : `${ url }&auto_play=1`;
  }

  private isDismiss ( reason : any ) : boolean {
    return reason === undefined
      || reason === ModalDismissReasons.BACKDROP_CLICK
      || reason === ModalDismissReasons.ESC;
  }
}
